import { formatEventDate } from '@/features/dates/date-helpers';
import type { EventResponse } from 'graphql/gql-types';

interface UseEventTooltipProps {
	count: number;
	events: EventResponse[];
}

interface EventTooltipData {
	shouldShow: boolean;
	title: string;
	content: string;
}

export const useEventTooltip = ({
	count,
	events,
}: UseEventTooltipProps): EventTooltipData => {
	if (count === 0) {
		return {
			shouldShow: false,
			title: '',
			content: '',
		};
	}

	const title = `${count} Event${count > 1 ? 's' : ''}`;

	const content = events
		.map((event) => {
			const name = event.event?.name || 'Unknown Event';
			const startDate = formatEventDate(event.start_date);
			const endDate = formatEventDate(event.end_date);
			const dateRange =
				startDate === endDate ? startDate : `${startDate} - ${endDate}`;
			const category = event.event?.category || '';
			const impact = event.event?.occ_impact
				? ` (Impact: ${event.event.occ_impact}%)`
				: '';

			return `${name}${category ? ` [${category}]` : ''}${impact}\n${dateRange}`;
		})
		.join('\n\n');

	return {
		shouldShow: true,
		title,
		content,
	};
};
